<template>
  <Navbar :url="imgurl" />
  <div class="homepage">
    <h1># {{ tag }}</h1>
    <div v-if="error">{{ error }}</div>
    <div v-if="posts" class='layout'>
      <Postlist :posts="postWithtag" />
      <Tagcloud :posts="posts" />
    </div>
    <div v-else>
      <Spinner/>
    </div>
  </div>
</template>

<script>
import Postlist from '../components/Postlist'
import Spinner from '../components/Spinner'
import Tagcloud from '../components/Tagcloud'
import Navbar from '../components/Navbar'
import getUser from '../composables/getUser'
import getPosts from '../composables/getPosts'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

export default {
  name: 'Tags',
  components: {
    Postlist,
    Spinner,
    Tagcloud,
    Navbar
  },
  setup() {
    // load非同步擷取posts資料，取出所有posts及error
    const { posts, error } = getPosts('posts');
    const route = useRoute();
    // return posts with certain tag
    const postWithtag = computed(() => {
      return posts.value.filter((item) => item.tags.includes(route.params.tag));
    });
    const { imgurl } = getUser();
    const tag = route.params.tag;
    return { posts, error, postWithtag, tag, imgurl }; 
  },
}
</script>
<style>
  .tag {
    max-width: 1200px;
    margin: 0 auto;
    padding: 10px;
  }
</style>